// Entry point temporário enquanto migramos o código legado.
// Importa o bundle atual para manter funcionalidade durante a refatoração.
import './legacy/voting-frontend';

console.info('[BDD Voting] Bundle moderno carregado (modo legado em execução).');
